/*@ngInject*/
const PolicyActionsRepository = function ($q, baseSharedPromiseRepository, currentSubmissionModel) {

    var sharedPromiseCache = {};

    angular.extend(this, baseSharedPromiseRepository);

    this.getGETSharedPromiseCache = function () {
        return sharedPromiseCache;
    };

    this.loadPolicyActions = function (policyId) {
        var url = '/rest/Actions?uri=com.firstbest.underwriting.policy.Policy:' + policyId + '&registrationIdentifier=/Policy/' + policyId,
            cacheKey = 'policyActions:' + policyId;

        if (currentSubmissionModel.hasActionsRegistration('/Policy/' + policyId)) {
            return $q.resolve(null);
        } else {
            return this.get(cacheKey, url).then(function (responseData) {
                currentSubmissionModel.addActionsRegistration('/Policy/' + policyId, url);
                return responseData;
            });
        }
    };
};

angular.module('gw-um-submission')
    .service('policyActionsRepository', PolicyActionsRepository);
